import { useState, useCallback, useMemo, useEffect } from 'react';
import useThinktankSearch from '../../hooks/useThinktankSearch';

import {FileContent} from '../FileContent'
import util from "../../../../utils/utils";

export const FileSearch = (props)=> {
    const {searchId,setMarkData,savedFoldListData} = props
    const [input,setInput] =useState('')
    const [tank,setTank] = useState('')
    const { loading,data,displayData,setQuery,setDisplayQuery} = useThinktankSearch();
    const [title,setTitle] =useState()
    const [upBtnVisible,setUpBtnVisible] = useState(false)
    useEffect(()=>{
        setInput('');
        setQuery({
            theme_id: '',
            search_content:''
        })
    },[])

    useEffect(()=>{
        document.getElementById("fileSearchScrollDiv")?.addEventListener("scroll",e=>{
            util?.throttle(setUpBtnStatus(),1000)
        })
    },[])

    const setUpBtnStatus = () => {
        let scrollTop = document.getElementById("fileSearchScrollDiv")?.scrollTop
        // console.log(scrollTop)
        if(scrollTop > 800){
            setUpBtnVisible(true)
        }else{
            setUpBtnVisible(false)
        }
    }
    // const dataSourceMap = {
    //     '美国布鲁金斯学会':'Brookings',
    //     '国务院发展研究中心':'Development_research_center',
    //     '韩国开发研究院':'KDI'
    // }
    const renderFileCard = (item) => {
        return (
            <div className="card-body p-4 relative">
                {/* <div className='flex gap-4 justify-end -mt-4 -ml-7 -mr-4'>
                    <div className="indexTag2">{item?.from_think_tank}</div>
                </div> */}
                <div className='absolute right-4'>
                    {/* <div className="indexTag bg-">{index + 1}</div> */}
                    <span>
                        <span className='text-sm text-gray-500'>相关度：</span>
                        <span className={`font-[600] ${item?.score > 90 ? 'text-orange-600 saturate-80' : item?.score > 80 ? 'text-primary saturate-80' : ''}`}>
                            {(item?.score)?.toFixed(2)}
                        </span>
                    </span>
                </div>

                <h2 className="card-title pr-24">
                    {item?.translated_title ? `${item?.title} (${item?.translated_title})` : item?.title}
                </h2>
                {/* <h2 className="card-title text-gray-800">
                    {item?.translated_title}
                </h2> */}
                <div className="card-actions gap-6 flex items-center mb-2">
                    <div className="text-gray-500">智库来源：{renderTankSourceTag(item?.from_think_tank)}</div>
                    {/* <div className="text-gray-500">智库来源：{item?.from_think_tank}</div> */}
                    {/* <div className="divider divider-horizontal"></div> */}
                    <div className="text-gray-500">作者/类型：{item?.author?.replaceAll('type:','')}</div>
                    {/* {item?.post_date && <div className="divider divider-horizontal"></div>} */}
                    {item?.post_date && <div className="text-gray-500">发布时间：{item?.post_date}</div>}
                </div>
                <div dangerouslySetInnerHTML={{ __html: item?.high_light_index && item?.high_light_index?.length > 0 ? 
                    util.HighlightText(item?.related_content, item?.high_light_index?.filter(item=>item?.end_position !== 0),true)
                    : item?.related_content }}>
                </div>
                {/* <div className="card-actions">
                    <div className="text-sm text-gray-500 inline-block">作者：</div><div className="text-sm text-gray-500">{item?.author}</div>
                </div>
                <div className="card-actions">
                    <div className="text-sm text-gray-500 inline-block">发表时间：</div><div className="text-sm text-gray-500">{item?.post_date}</div>
                </div> */}
                {/* <div>
                    {item?.show_content}
                </div> */}
                <div className="card-actions justify-between items-center">
                    <div className="flex-1">
                        {
                            item?.theme && 
                            <>
                                <div className="text-sm text-gray-500 inline-block">主题分类：</div>
                                {[...new Set(item?.theme?.split('&')?.filter(txt=>txt !== '其他' && txt !== ':'))]?.map(i => (
                                    <div className="badge badge-outline inline-block mr-2">{i?.replaceAll(/:/g,"")}</div> 
                                ))}
                            </>
                        }
                    </div>
                    <div>
                        <button className="btn btn-ghost btn-sm" onClick={(e)=>{
                            e.stopPropagation();
                            setTitle(item?.title);
                            document.getElementById('my_article_modal').showModal()}}>
                            <span className="badge bg-yellow-200">{item?.related_num}</span>
                            查看原文
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth='1.5' stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                            </svg>
                        </button>
                        <button className="btn btn-ghost btn-sm" 
                            onClick={(e)=>{
                                e.stopPropagation();
                                setMarkData(
                                    {
                                        data_source:item?.from_think_tank,
                                        source_id:item?.content_index
                                    }
                                );
                                document.getElementById('my_mark_modal').showModal()
                            }}
                        >
                        {
                            savedFoldListData?.some(i=>i?.save_id_list?.includes(item?.source_id)) ? 
                            <>
                                已收藏
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-warning">
                                <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clipRule="evenodd" />
                                </svg>
                            </> : 
                            <>
                                收藏
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
                                </svg>
                            </>
                        }
                        </button>
                    </div>
                </div>
            </div>
        )
    }
    const renderSearchResults = () => {
        // const data = tank==='布鲁金斯学会' ? brookingsData : tank==='韩国开发研究院' ? kdiData : tank==='国务院发展研究中心' ? developData : [];
        // const loading = tank==='布鲁金斯学会' ? brookingsLoading : tank==='韩国开发研究院' ? kdiLoading : tank==='国务院发展研究中心' ? developLoading : false;
        return (
            <>            
            {
                loading ?
                <div className="flex flex-col gap-4 w-full p-4">
                    <div className="skeleton h-6 w-full"></div>
                    <div className="skeleton h-6 w-full"></div>
                    <div className="skeleton h-6 w-full"></div>
                </div> : 
                // <>
                //     {!searched ?
                //     <div className="w-full py-8 text-center">
                //     </div> :
                    <>
                        {data && <div className='flex flex-wrap gap-2 px-4 pb-2 items-center justify-start'>
                            <span className="whitespace-nowrap">
                            智库来源：
                            </span>
                            <>
                            {renderTankSourceTabs()}
                            </>
                        </div>}

                        <div className='flex w-full items-center gap-4 px-4'>
                            <div className="divider divider-start flex-1">为您找到{displayData?.length ?? 0}条相关内容</div>
                        </div>
                        {
                            displayData?.length > 0 ?
                            <>
                                <div className="w-full">
                                    <div className='lg:m-4 border'>
                                        <table className="table table-zebra">
                                            <tbody>
                                                {displayData?.map((item,index) => (
                                                    <tr  className="hover">
                                                        <th>{index +1 }</th>
                                                        <td className='p-0'>
                                                            {renderFileCard(item)}                                                
    
                                                        </td>
                                                    </tr>
                                                ))}
    
                                            </tbody>
                                        </table>
    
                                    </div>
                                </div>
                            </> :
                            <div className="w-full py-8 text-center">
                                暂无检索结果
                            </div>
                        }
                    </>
                //     }
                // </>
            }
        </>
    
        )
    }
    // const tabs = [
    //     '布鲁金斯学会',
    //     '韩国开发研究院',
    //     '国务院发展研究中心',
    //     '卡耐基国际和平基金会',
    //     '世界经济论坛',
    //     '城市研究所',
    //     '华盛顿战略与国际问题研究中心',
    //     // '美国进步中心',
    //     '北大西洋理事会',
    //     '瓦加斯基金会'
    // ]

    const renderTankSourceTag = (txt) => {
        const tabs = [...new Set(data?.map(item=>item?.from_think_tank))]
        const i = tabs.indexOf(txt)
        const colors = ['','btn-primary','btn-secondary','btn-accent']
        return (
            <span className={`btn btn-sm btn-outline ${colors[i]}`}>{txt}</span>
        )
    }

    const renderTankSourceTabs = () => {
        const tabs = [...new Set(data?.map(item=>item?.from_think_tank))]
        return (
            <>
                {tabs?.map(item=><button className={`${tank===item ? 'btn btn-sm btn-active btn-neutral' : 'btn btn-sm'}`}
                    onClick={()=>{setTank(item);setDisplayQuery({from_think_tank:item})}}
                    >{item}</button>)}
                {tank && <button className='btn btn-sm btn-link' onClick={()=>{setTank();setDisplayQuery({from_think_tank:'all'})}}>全部来源</button>}
            </>
        )
    }
    return (
        <div className="p-4 w-full overflow-auto bg-base-100 rounded-box" id="fileSearchScrollDiv">
            {upBtnVisible && <div id="back-to-top" className="fixed bottom-3 right-1000 z-10">
                <button className="btn btn-circle btn-outline bg-base-100" 
                    onClick={()=>{
                        let element = document.getElementById("fileSearchScrollDiv");
                        element.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        })}
                    }
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l7.5-7.5 7.5 7.5m-15 6l7.5-7.5 7.5 7.5" />
                    </svg>
                </button>
            </div>}
            <FileContent
                title={title}
            />
            <div className='flex gap-8 p-4 items-center justify-start'>
                <h2 className="card-title whitespace-nowrap hidden lg:flex">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" />
                    </svg>
                    海外智库洞察
                </h2>
                <div className="join w-full max-w-4xl">
                    <input 
                    className="input input-bordered join-item w-full" 
                    placeholder='输入您感兴趣的搜索内容...' 
                    value={input} 
                    onChange={(e)=>setInput(e.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                          setQuery({            
                            // theme_id:activeMenuId === INIT_THEME_ID ? '' : activeMenuId,
                            theme_id:'',
                            search_content:input
                        })
                        }
                      }
                }
                    />
                    <button className="btn join-item btn-outline" onClick={()=>setQuery({            
                        // theme_id:activeMenuId === INIT_THEME_ID  ? '' : activeMenuId,
                        theme_id:'',
                        search_content:input
                    })}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth='1.5' stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                        </svg>
                    </button>
                </div>
            </div>
            {/* <div className=' overflow-x-auto'>
                <ul className="menu menu-vertical lg:menu-horizontal bg-base-100 rounded-box px-4">
                    {tabs?.map((item,index)=>
                        <li><a onClick={()=>setTank(item)} className={`${tank===item ? 'active' : ''}`}>{item}</a></li>
                    )}
                </ul>

            </div> */}

            {/* <div role="tablist" className="tabs tabs-bordered tabs-lg">
                {tabs?.map((item,index)=>
                    <>
                        <input type="radio" name={index} role="tab" className="tab" aria-label={item}/>
                        <div role="tabpanel" className="tab-content bg-base-100 pb-4"> */}
                            {renderSearchResults()}
                        {/* </div>
                    </>
                )}
            </div> */}
        </div>
    )
}